var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductRequisition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.4165V5.6665C16.6666 4.26637 16.6666 3.56631 16.3942 3.03153C16.1545 2.56112 15.772 2.17867 15.3016 1.93899C14.7668 1.6665 14.0668 1.6665 12.6666 1.6665H7.33331C5.93318 1.6665 5.23312 1.6665 4.69834 1.93899C4.22793 2.17867 3.84548 2.56112 3.6058 3.03153C3.33331 3.56631 3.33331 4.26637 3.33331 5.6665V14.3332C3.33331 15.7333 3.33331 16.4334 3.6058 16.9681C3.84548 17.4386 4.22793 17.821 4.69834 18.0607C5.23312 18.3332 5.93318 18.3332 7.33331 18.3332H9.99998M11.6666 9.1665H6.66665M8.33331 12.4998H6.66665M13.3333 5.83317H6.66665M12.0833 15.8332L13.75 17.4998L17.5 13.7498",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductRequisition);
export default __webpack_public_path__ + "static/media/productRequisition.d22be47b2ff20127f76a0a2006dc287a.svg";
export { ForwardRef as ReactComponent };